
























































































































































































































import api from "@/api/index"; //ABP API接口
import {Vue, Component} from "vue-property-decorator";

import {ActivityDto, PagedResultDto} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import ExportButton from "@/components/ExportButton/index.vue";
import QrcodeVue from "qrcode.vue";

@Component({
  name: "ActivityList",
  components: {
    ExportButton,
    PagedTableView,
    QrcodeVue,
  },
})
export default class ActivityList extends Vue {
  queryForm = {
    title: "",
    status: "",
  };
  exportFieldList = [
    "活动标题",
    "活动内容",
    "主办方",
    "协办方",
    "领队",
    "单次积分",
    "人工审核",
    "志愿者积分",
    "志愿者星级",
    "限制报名人数",
    "活动开始时间",
    "活动结束时间",
    "活动时长(小时)",
    "报名截止时间",
    "活动地区",
    "详细地址"
  ];
  activityStatusList: any[] = [
    {
      disabled: false,
      group: null,
      selected: false,
      text: "预录入(保存)",
      value: "Saved",
    },
    // {
    //   disabled: false,
    //   group: null,
    //   selected: false,
    //   text: "退回",
    //   value: "SendBacked",
    // },
    // {
    //   disabled: false,
    //   group: null,
    //   selected: false,
    //   text: "提交",
    //   value: "Submited",
    // },
    // {
    //   disabled: false,
    //   group: null,
    //   selected: false,
    //   text: "审批通过",
    //   value: "Approved",
    // },
    {
      disabled: false,
      group: null,
      selected: false,
      text: "已经发布",
      value: "Published",
    },
    // {
    //   disabled: false,
    //   group: null,
    //   selected: false,
    //   text: "结束",
    //   value: "Finished",
    // },
    // {
    //   disabled: false,
    //   group: null,
    //   selected: false,
    //   text: "删除",
    //   value: "Deleted",
    // },
  ];

  id = 0;

  created() {
    // api.enumService
    //   .getValues({ typeName: "ActivityStatus" })
    //   .then((res: any) => {
    //     this.activityStatusList = res;
    //   });
  }

  // 获取表数据
  fetchData(params: any) {
    console.log("test:" + params);
    return api.activity.getAll(params);
  }

  // 新建
  handleCreate() {
    this.$router.push({
      name: "ActivityEdit",
      params: {id: "0"},
    });
  }

  // 编辑
  handleEdit(index: number, row: ActivityDto) {
    this.id = row.id!;
    this.$router.push({
      name: "ActivityEdit",
      params: {id: row.id! + ""},
    });
  }

  // 发布
  handlePublish(index: number, item: ActivityDto) {
    this.$confirm("确定发布吗?", "提示").then(() => {
      api.activity.publish({body: {id: item.id}}).then((res) => {
        this.$message.success("发布成功");
      });
    });
  }

  // 取消发布
  handleCancelPublish(index: number, item: ActivityDto) {
    this.$confirm("确定取消发布吗?", "提示").then(() => {
      api.activity.cancelPublish({body: {id: item.id}}).then((res) => {
        this.$message.success("取消成功");
      });
    });
  }

  // 删除
  async handleDelete(index: number, row: ActivityDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.activity
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  handleQr(index: number, row: ActivityDto) {
    this.$message({
      type: "info",
      message: "待开发",
    });
  }

  handleCheckIn(index: number, row: ActivityDto) {
    this.$router.push({
      name: "ActivityCheckIn",
      params: {id: `${row.id!}`},
      query: {},
    });
  }

  handleDetail(index: number, row: ActivityDto) {
    this.$router.push({
      name: "ActivityDetail",
      params: {id: `${row.id!}`},
      query: {},
    });
  }

  hasDisplayPermission(permissionCode: string) {
    return this.hasPermission(permissionCode);
  }

  // 控制二维码弹窗显示
  qrCodeDialogVisible = false;
  // 二维码的值
  qrCodeValue = "";
  // 当前活动的标题
  currentActivityTitle = "";

  // 生成二维码
  generateQrCode(activity: ActivityDto) {
    // 根据你提供的URL格式生成二维码内容
    const url = `https://yiheshuyuan-mobile.gongyila.com/activity/${activity.id}`;
    this.qrCodeValue = url;
    this.currentActivityTitle = activity.title || '';
    this.qrCodeDialogVisible = true;
  }

  // 复制链接到剪贴板
  copyUrl() {
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', this.qrCodeValue);
    document.body.appendChild(input);
    input.select();
    if (document.execCommand('copy')) {
      this.$message.success('链接已复制到剪贴板');
    }
    document.body.removeChild(input);
  }

  // 下载二维码
  downloadQrCode() {
    const qrCodeCanvas = (this.$refs.qrCode as any).$el.querySelector('canvas');
    const imageUrl = qrCodeCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `${this.currentActivityTitle}-活动二维码.png`;
    link.click();
    this.$message.success('二维码已下载');
  }
}
